module.exports = __webpack_public_path__ + "7a46cc5dabfc1d7b5f864d95250aca40.svg";